import React, { useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalBrand as setGlobalBrandAction } from "@/shared/store/brandSlice";
import { reloadOtherTabs } from "@/shared/helpers/authHelper";
import { useNavigate, useLocation } from "react-router-dom";
import { userBrandsSelector } from "@/shared/store/brandSlice";
import { getRedirectPath } from "@/helpers/localStore";
import { useAppTheme } from "@/helpers/contexts/themeContext";
import { loginWithToken } from "@/shared/helpers/tokenBasedLoginHelper";
import { getDashboardPath } from "@/helpers/utils";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { USER_ROLE } from "@/config/constants";

type BrandOption = {
  brand_name?: string;
  id: number | string;
};

type BrandState = {
  brand?: {
    userBrands?: BrandOption[];
  };
};

type SelectBrandContext = {
  loggedInUserRole?: string;
};

type AppThemeContext = {
  getTheme: (_brandId: BrandOption["id"]) => void;
};

const selectUserBrands = userBrandsSelector as unknown as (
  _state: unknown
) => BrandOption[] | undefined;

const SelectBrand = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { getTheme } = useAppTheme() as AppThemeContext;
  const brands = useSelector((state: BrandState) => selectUserBrands(state)) as
    | BrandOption[]
    | undefined;
  const setGlobalBrand = useCallback(
    (brand: BrandOption) => {
      reloadOtherTabs();
      dispatch(setGlobalBrandAction(brand));
    },
    [dispatch]
  );

  const { loggedInUserRole } = useContext(GlobalContext) as SelectBrandContext;

  /**
   * @method handleOnClickBrand
   * @description handle on click to brand
   * @param {*} brand
   */
  const handleOnClickBrand = (brand: BrandOption) => {
    loginWithToken({ data: brand });
    getTheme(brand.id);
    setGlobalBrand(brand);

    // Retrieve the stored redirect path from sessionStorage or default to "/dashboard"
    const redirectPath = getRedirectPath();
    if (redirectPath && location?.pathname !== redirectPath) {
      navigate(redirectPath, { replace: true });
    } else {
      if (loggedInUserRole === USER_ROLE.PARTICIPANT.NAME) {
        navigate(`/launch-campaign`, {
          replace: true,
        });
        return;
      }
      navigate(getDashboardPath(), {
        replace: true,
      });
    }
  };

  return (
    <div className="select-brand-page pt-3">
      <div className="container select-brand">
        <div className="row align-items-stretch justify-content-center mb-3 brands">
          {brands &&
            brands.length &&
            brands.map((brand) => (
              <div
                onClick={() => handleOnClickBrand(brand)}
                className="col-lg-4 col-sm-6 my-2"
                key={brand.id}
              >
                <div className="brand d-flex-center text20M_SemiBold548E8D text-break">
                  {brand.brand_name}
                  {/* <ImageRP
                    src={brand.brand_logo}
                    className="img-fluid"
                    type="BRAND"
                    alt={brand.brand_name}
                  /> */}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SelectBrand;
